<template>
  
    <div class="card">
      <v-form @submit.prevent="resetPassword" ref="form">
          <div class="resetTitle mb-2">Reset Password</div>
          <div class="img-wrapper">
              <img :src="require('../assets/reset.svg')" alt="" />
            </div>
            <div class="pa-0" align="start" >
              <p class="instructions">Set the New Password.</p>
              <p class="instructions-text">Set new password to access your secure data and files.</p>
            </div>
          <div class="pa-0 pt-2">
            <v-text-field
                density="compact"
                hide-details="auto"
                @click:append-inner="showPassword1 = !showPassword1"
                prepend-inner-icon="mdi mdi-lock"
                placeholder="Enter New Password"
                :rules="passwordRule"
                v-model="newPassword"
                variant="outlined"
                @change="passwordError = false"
               v-bind:type="[showPassword1 ? 'text' : 'password']"
               :append-inner-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                 class="custom-text-field"
              />
          </div>
          <div class="pa-0 pt-2">
            <v-text-field
                density="compact"
                hide-details="auto"
                @click:append-inner="showPassword = !showPassword"
                prepend-inner-icon="mdi mdi-lock"
                placeholder="Re-enter New Password"
                v-model="confirmPassword"
                 @change="passwordError = false"
                variant="outlined"
                v-bind:type="[showPassword ? 'text' : 'password']"
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                 class="custom-text-field"
              />
            <v-error v-if="passwordError" class="error">{{ message }}</v-error>
          </div>
          <div class="pa-0 pt-2" cols="12" align="center">
            <v-btn
              block
              color="#D0103A"
              type="submit"
              size="large"
              :disabled="loading"
              :loading="loading"
              class="text-white mt-2"
              >Reset</v-btn
            >
          </div>
      </v-form>
    </div>
    
 
</template>

<script>
import ResetPasswordService from "../api/service/ResetPasswordService.js";
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      passwordRule: [
        (value) => {
          if (value) return true;
          return "Password is required";
        },
        (value) => {
          if (/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{6,}/.test(value)) return true;
          return "Password must contain at least lowercase letter, one number, a special character and one uppercase letter";
        },
      ],
      showPassword: false,
      showPassword1: false,
      newPassword: "",
      confirmPassword: "",
      message: null,
      passwordError: false,
    };
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      if (this.passwordRule.every((rule) => rule(this.newPassword) === true)) {
        var params = this.$route.query;
        // console.log(params,'alert111')
        localStorage.setItem("REDIRECT_URL", params.redirectUrl);

        if (
          this.newPassword == this.confirmPassword &&
          this.newPassword != "" &&
          this.confirmPassword != ""
        ) {
          this.passwordError = false;
          var res = await ResetPasswordService.resetPassword({
            uid: params.uid,
            newPassword: this.newPassword,
            appId: params.appId,
          });
          console.log(res);
          this.$router.push({ path: "/success" });
        } else {
          this.loading = false;
          this.passwordError = true;
          this.message = "Password does not match";
        }
      } else {
        this.loading = false;
        this.passwordError = true;
        this.message = "Password does not meet the requirements";
      }
    },
  },
};
</script>

<style scoped>
>>>.v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}
>>>.v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}
</style>
